(() => {
  const money = (cents) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        style: 'currency', currency: 'GBP'
      }).format(Number(cents || 0) / 100);
    } catch (_) {
      return `£${(Number(cents || 0) / 100).toFixed(2)}`;
    }
  };

  const debounce = (fn, wait = 100) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => fn(...args), wait);
    };
  };

  document.querySelectorAll('[data-smv3-product]').forEach((root) => {
    const media = [...root.querySelectorAll('[data-smv3-media]')];
    const thumbs = [...root.querySelectorAll('[data-smv3-thumb]')];
    let active = 0;

    const showMedia = (index) => {
      if (!media.length) return;
      active = (index + media.length) % media.length;
      media.forEach((el, i) => {
        el.hidden = i !== active;
        el.classList.toggle('is-active', i === active);
      });
      thumbs.forEach((el, i) => el.classList.toggle('is-active', i === active));
    };

    root.querySelector('[data-smv3-prev]')?.addEventListener('click', () => showMedia(active - 1));
    root.querySelector('[data-smv3-next]')?.addEventListener('click', () => showMedia(active + 1));
    thumbs.forEach((el, i) => el.addEventListener('click', () => showMedia(i)));

    /* Native-feeling horizontal swipe for the product gallery on touch devices. */
    const stage = root.querySelector('.smv3__stage');
    let touchStartX = 0;
    let touchStartY = 0;
    stage?.addEventListener('touchstart', (event) => {
      const point = event.touches?.[0];
      if (!point) return;
      touchStartX = point.clientX;
      touchStartY = point.clientY;
    }, { passive: true });
    stage?.addEventListener('touchend', (event) => {
      const point = event.changedTouches?.[0];
      if (!point || media.length < 2) return;
      const dx = point.clientX - touchStartX;
      const dy = point.clientY - touchStartY;
      if (Math.abs(dx) < 45 || Math.abs(dx) <= Math.abs(dy) * 1.15) return;
      showMedia(dx < 0 ? active + 1 : active - 1);
    }, { passive: true });

    /* Stable feature rail: arrows remain in place and only change disabled/visibility state. */
    const featureRail = root.querySelector('[data-smv3-feature-rail]');
    const featureStrip = root.querySelector('[data-smv3-feature-strip]');
    const featurePrev = root.querySelector('[data-smv3-feature-prev]');
    const featureNext = root.querySelector('[data-smv3-feature-next]');

    const updateFeatureArrows = () => {
      if (!featureRail || !featureStrip || !featurePrev || !featureNext) return;
      const maxScroll = Math.max(0, featureStrip.scrollWidth - featureStrip.clientWidth);
      const hasOverflow = maxScroll > 6;
      featureRail.classList.toggle('has-overflow', hasOverflow);
      featurePrev.disabled = !hasOverflow || featureStrip.scrollLeft <= 3;
      featureNext.disabled = !hasOverflow || featureStrip.scrollLeft >= maxScroll - 3;
    };

    const featureStep = () => {
      const firstCard = featureStrip?.querySelector('.smv3__feature');
      return firstCard ? firstCard.getBoundingClientRect().width + 10 : 160;
    };

    featurePrev?.addEventListener('click', () => featureStrip?.scrollBy({ left: -featureStep(), behavior: 'smooth' }));
    featureNext?.addEventListener('click', () => featureStrip?.scrollBy({ left: featureStep(), behavior: 'smooth' }));
    featureStrip?.addEventListener('scroll', debounce(updateFeatureArrows, 40), { passive: true });
    if ('ResizeObserver' in window && featureStrip) {
      const observer = new ResizeObserver(debounce(updateFeatureArrows, 80));
      observer.observe(featureStrip);
    } else {
      window.addEventListener('resize', debounce(updateFeatureArrows, 120), { passive: true });
    }
    requestAnimationFrame(() => requestAnimationFrame(updateFeatureArrows));

    /* Let Shopify app blocks mount normally, then reveal the wrapper only when an offer has real rendered content. */
    const appSection = root.querySelector('.smv3__app-section');
    const appBlocks = [...root.querySelectorAll('[data-smv3-app-block]')];

    const elementIsVisible = (el) => {
      if (!el || !el.isConnected) return false;
      const style = window.getComputedStyle(el);
      const rect = el.getBoundingClientRect();
      return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 2 && rect.height > 2;
    };

    const treeHasOffer = (node) => {
      if (!node) return false;
      const candidates = [...node.querySelectorAll('button, a[href], img[src], iframe[src], [class*="offer" i], [class*="bundle" i], [class*="bogo" i], [class*="upsell" i]')];
      if (candidates.some(elementIsVisible)) return true;
      return [...node.querySelectorAll('*')].some((host) => host.shadowRoot && treeHasOffer(host.shadowRoot));
    };

    const isStandaloneKlarnaBlock = (block) => {
      const identity = `${block.id || ''} ${block.className || ''} ${block.querySelector('.shopify-app-block')?.id || ''}`.toLowerCase();
      return identity.includes('klarna') && !identity.includes('qikify') && !identity.includes('qbk');
    };

    const updateAppSection = () => {
      let hasOffer = false;
      appBlocks.forEach((block) => {
        if (isStandaloneKlarnaBlock(block)) { block.style.display = 'none'; return; }
        block.style.display = '';
        if (treeHasOffer(block)) hasOffer = true;
      });
      appSection?.classList.toggle('is-visible', hasOffer);
      appSection?.setAttribute('aria-hidden', hasOffer ? 'false' : 'true');
    };

    if (appSection) {
      const appObserver = new MutationObserver(debounce(updateAppSection, 100));
      appObserver.observe(appSection, { childList: true, subtree: true, attributes: true, characterData: true });
      [0,250,750,1500,3000,5000,8000,12000,18000].forEach((delay) => setTimeout(updateAppSection, delay));
      window.addEventListener('load', updateAppSection, { once: true });
    }

    const qty = root.querySelector('[data-smv3-qty]');
    const stickyQty = root.querySelector('[data-smv3-sticky-qty]');
    const setQty = (value) => {
      const next = Math.max(1, Number(value || 1));
      if (qty) qty.value = next;
      if (stickyQty) stickyQty.value = next;
    };
    root.querySelector('[data-smv3-qty-minus]')?.addEventListener('click', () => setQty(Number(qty?.value || 1) - 1));
    root.querySelector('[data-smv3-qty-plus]')?.addEventListener('click', () => setQty(Number(qty?.value || 1) + 1));
    root.querySelector('[data-smv3-sticky-minus]')?.addEventListener('click', () => setQty(Number(stickyQty?.value || 1) - 1));
    root.querySelector('[data-smv3-sticky-plus]')?.addEventListener('click', () => setQty(Number(stickyQty?.value || 1) + 1));
    qty?.addEventListener('input', () => setQty(qty.value));
    stickyQty?.addEventListener('input', () => setQty(stickyQty.value));

    const variantJson = root.querySelector('[data-smv3-variants]');
    const inventoryJson = root.querySelector('[data-smv3-inventory]');
    if (!variantJson) return;

    let variants = [];
    let inventory = {};
    try { variants = JSON.parse(variantJson.textContent); } catch (_) { return; }
    try { inventory = inventoryJson ? JSON.parse(inventoryJson.textContent) : {}; } catch (_) { inventory = {}; }

    const selects = [...root.querySelectorAll('[data-smv3-option-index]')];
    const variantInput = root.querySelector('[data-smv3-variant-id]');
    const add = root.querySelector('[data-smv3-add]');
    const stickyAdd = root.querySelector('[data-smv3-sticky-add]');
    const price = root.querySelector('[data-smv3-price]');
    const stickyPrice = root.querySelector('[data-smv3-sticky-price]');
    const vat = root.querySelector('[data-smv3-vat]');
    const compare = root.querySelector('[data-smv3-compare]');
    const save = root.querySelector('[data-smv3-save]');
    const priceCard = root.querySelector('[data-smv3-price-card]');
    const sku = root.querySelector('[data-smv3-sku]');
    const stickySku = root.querySelector('[data-smv3-sticky-sku]');
    const skuCopied = root.querySelector('[data-smv3-sku-copied]');
    const availability = root.querySelector('[data-smv3-availability]');
    const availabilityTitle = root.querySelector('[data-smv3-availability-title]');
    const stock = root.querySelector('[data-smv3-stock]');
    const expressMessage = root.querySelector('[data-sm-express-message]');
    const stockCall = root.querySelector('[data-smv3-stock-call]');
    const klarnaPopup = root.querySelector('[data-smv3-klarna-popup]');
    const openKlarna = () => { if (klarnaPopup) { klarnaPopup.classList.add('is-open'); klarnaPopup.setAttribute('aria-hidden','false'); document.body.classList.add('smv3-popup-open'); } };
    const closeKlarna = () => { if (klarnaPopup) { klarnaPopup.classList.remove('is-open'); klarnaPopup.setAttribute('aria-hidden','true'); document.body.classList.remove('smv3-popup-open'); } };
    root.querySelector('[data-smv3-klarna-open]')?.addEventListener('click', openKlarna);
    root.querySelectorAll('[data-smv3-klarna-close]').forEach((button) => button.addEventListener('click', closeKlarna));
    klarnaPopup?.addEventListener('click', (event) => { if (event.target === klarnaPopup) closeKlarna(); });
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && klarnaPopup?.classList.contains('is-open')) closeKlarna(); });

    const getSelectedVariant = () => {
      if (!selects.length) return variants.find(v => String(v.id) === String(variantInput?.value)) || variants[0];
      const chosen = selects.map(s => s.value);
      return variants.find(v => v.options.every((option, index) => String(option) === String(chosen[index])));
    };

    const updateVariant = () => {
      const variant = getSelectedVariant();
      if (!variant) {
        if (add) { add.disabled = true; add.textContent = 'Unavailable'; }
        if (stickyAdd) { stickyAdd.disabled = true; stickyAdd.textContent = 'Unavailable'; }
        return;
      }

      const live = inventory[String(variant.id)] || {};
      const available = typeof live.available === 'boolean' ? live.available : Boolean(variant.available);
      const stockQty = Math.max(0, Number(live.quantity ?? variant.inventory_quantity ?? 0));
      const liveSku = live.sku || variant.sku || '';

      if (variantInput) variantInput.value = variant.id;
      if (price) price.innerHTML = `${money(variant.price)} <small>Excl. VAT</small>`;
      if (stickyPrice) stickyPrice.textContent = money(variant.price);
      if (vat) vat.textContent = `${money(Math.round(variant.price * 1.2))} Inc. VAT`;
      const klarna = root.querySelector('[data-smv3-klarna]');
      if (klarna) klarna.textContent = money(Math.floor(variant.price / 3));
      root.querySelectorAll('[data-smv3-klarna-popup-amount]').forEach((el) => { el.textContent = money(Math.floor(variant.price / 3)); });
      root.querySelectorAll('[data-smv3-klarna-popup-total]').forEach((el) => { el.textContent = money(variant.price); });
      const featuredMediaId = variant.featured_media?.id || variant.featured_image?.id || null;
      if (featuredMediaId) {
        const mediaIndex = media.findIndex((el) => String(el.dataset.smv3MediaId) === String(featuredMediaId));
        if (mediaIndex >= 0) showMedia(mediaIndex);
      }
      if (sku) sku.textContent = liveSku;
      if (stickySku) stickySku.textContent = liveSku;
      if (skuCopied) skuCopied.textContent = '';

      const hasCompare = Number(variant.compare_at_price || 0) > Number(variant.price || 0);
      compare?.classList.toggle('is-hidden', !hasCompare);
      if (compare && hasCompare) compare.textContent = `${money(variant.compare_at_price)} Excl. VAT`;
      if (save) {
        save.hidden = !hasCompare;
        if (hasCompare) save.textContent = `Save ${money(variant.compare_at_price - variant.price)}`;
      }
      priceCard?.classList.toggle('smv3__price-card--standard', !hasCompare);

      [add, stickyAdd].forEach(button => {
        if (!button) return;
        button.disabled = !available;
        button.textContent = available ? 'Add to cart' : 'Sold out';
      });
      availability?.classList.toggle('is-unavailable', !available);
      if (availability) {
        if (available) availability.removeAttribute('data-sm-express-disabled');
        else availability.setAttribute('data-sm-express-disabled', 'true');
      }
      if (availabilityTitle) availabilityTitle.textContent = available ? `In Stock and Ready to Order (${stockQty})` : 'Currently unavailable';
      if (stock) stock.textContent = available ? `${stockQty} available` : 'Unavailable';
      if (stockCall) stockCall.hidden = available;
      if (expressMessage) { expressMessage.hidden = !available; if (!available) expressMessage.textContent = ''; }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
      root.dispatchEvent(new CustomEvent('smv3:variant-change', { detail: { variant, available, stockQty } }));
    };

    selects.forEach(select => select.addEventListener('change', updateVariant));
    updateVariant();

    const copySku = async () => {
      if (!sku || !sku.textContent.trim()) return;
      const value = sku.textContent.trim();
      try {
        await navigator.clipboard.writeText(value);
      } catch (_) {
        const area = document.createElement('textarea');
        area.value = value;
        area.setAttribute('readonly', '');
        area.style.position = 'fixed';
        area.style.opacity = '0';
        document.body.appendChild(area);
        area.select();
        document.execCommand('copy');
        area.remove();
      }
      if (skuCopied) {
        skuCopied.textContent = 'Copied';
        clearTimeout(skuCopied._smv3Timer);
        skuCopied._smv3Timer = setTimeout(() => { skuCopied.textContent = ''; }, 1600);
      }
    };
    sku?.addEventListener('click', copySku);
    sku?.addEventListener('keydown', event => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        copySku();
      }
    });


    /* Express-delivery information popup. Uses delegation because the info button is injected by sm-global.js. */
    const setDeliveryPopup = (popup, open) => {
      if (!popup) return;
      popup.classList.toggle('is-open', open);
      popup.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.documentElement.classList.toggle('smv3-popup-open', open);
      if (open) popup.querySelector('[data-sm-popup-close]')?.focus();
    };

    root.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-sm-popup-open]');
      if (opener && root.contains(opener)) {
        const popup = root.querySelector(`#${CSS.escape(opener.dataset.smPopupOpen || '')}`);
        if (popup) {
          event.preventDefault();
          setDeliveryPopup(popup, true);
        }
        return;
      }

      const closer = event.target.closest('[data-sm-popup-close]');
      if (closer && root.contains(closer)) {
        const popup = closer.closest('.popup-overlay');
        event.preventDefault();
        setDeliveryPopup(popup, false);
        return;
      }

      if (event.target.classList?.contains('popup-overlay')) setDeliveryPopup(event.target, false);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      root.querySelectorAll('.popup-overlay.is-open').forEach((popup) => setDeliveryPopup(popup, false));
    });

    /* Sticky add-to-cart appears only after the main purchase controls leave view. */
    const stickyCart = root.querySelector('[data-smv3-sticky-cart]');
    const purchaseRow = root.querySelector('.smv3__purchase-row');
    const footer = document.querySelector('footer');
    let purchaseVisible = true;
    let footerVisible = false;
    const setStickyVisibility = () => {
      if (!stickyCart) return;
      stickyCart.hidden = purchaseVisible || footerVisible;
      document.body.classList.toggle('smv3-sticky-visible', !stickyCart.hidden);
    };
    if ('IntersectionObserver' in window) {
      if (purchaseRow) new IntersectionObserver(entries => {
        purchaseVisible = entries[0]?.isIntersecting ?? true;
        setStickyVisibility();
      }, { threshold: 0.05 }).observe(purchaseRow);
      if (footer) new IntersectionObserver(entries => {
        footerVisible = entries[0]?.isIntersecting ?? false;
        setStickyVisibility();
      }, { threshold: 0 }).observe(footer);
    }
    stickyAdd?.addEventListener('click', () => {
      setQty(stickyQty?.value || qty?.value || 1);
      if (add && !add.disabled) add.click();
    });

    /* Redesigned mount compatibility check using the existing VESA data. */
    const confidence = root.querySelector('.smv3__confidence');
    if (confidence) {
      const input = confidence.querySelector('.smv3__confidence-input');
      const button = confidence.querySelector('.smv3__confidence-button');
      const status = confidence.querySelector('.smv3__confidence-status');
      const mountVesa = (confidence.dataset.mountVesa || '').toLowerCase().replace(/\s/g, '');
      button?.addEventListener('click', () => {
        const entered = (input?.value || '').trim();
        if (!entered) {
          status.textContent = 'Enter the display SKU to run the compatibility check.';
          status.className = 'smv3__confidence-status is-warning';
          return;
        }
        status.textContent = mountVesa
          ? `SKU ${entered} recorded. Confirm the display VESA pattern matches: ${confidence.dataset.mountVesa}.`
          : `SKU ${entered} recorded. Contact our team to confirm compatibility before ordering.`;
        status.className = 'smv3__confidence-status is-success';
      });
    }
  });
})();
